import { JSX } from 'preact'
import classnames from 'classnames'
import { useTemplateTags } from '../useTemplateTags'
import { useFormContext } from '../Form/useFormContext'

interface Props {
  name: string
  label?: string
  value: string
  required?: boolean
  className?: string
}

export function Checkbox({ name, label, value, required, className }: Props): JSX.Element {
  const { template } = useTemplateTags()
  const { getMultiValue, setValue } = useFormContext()
  const values = getMultiValue(name)
  // for a group of checkboxes with the same name, if at least one is checked, control should be valid
  const isRequired = required && values.length === 0
  const isChecked = values.includes(value)

  const handleChange = (e: Event) => {
    const val = (e.target as HTMLInputElement).value
    const checked = (e.target as HTMLInputElement).checked
    setValue(name, {
      value: checked ? [...values, val] : values.filter(v => v !== val),
    })
  }

  return (
    <label className={classnames(className)}>
      <input
        type="checkbox"
        name={name}
        value={value}
        required={isRequired}
        checked={isChecked}
        onChange={handleChange}
      />
      <span dangerouslySetInnerHTML={{ __html: template(label) }} />
    </label>
  )
}
